export default {
    'driverPerformanceFunctionTab_intervention_intervention': 'Intervención',
    'driverPerformanceFunctionTab_intervention_enableIntervention': 'Habilitar Intervención',
    'driverPerformanceFunctionTab_intervention_riskEvent': 'Eventos de Riesgo',
    'driverPerformanceFunctionTab_intervention_category': 'Categoría',
    'driverPerformanceFunctionTab_intervention_eventName': 'Nombre del evento',
    'driverPerformanceFunctionTab_intervention_severity': 'Severidad',
    'driverPerformanceFunctionTab_intervention_assignedEvents': 'Eventos Asignados',
    'driverPerformanceFunctionTab_intervention_noEventsAssigned': 'Aún no hay eventos asignados',
    'driverPerformanceFunctionTab_intervention_eventsLoaded': '{loaded} de {total} eventos cargados',
    'driverPerformanceFunctionTab_intervention_interventionEventRequired': 'Se requiere al menos un evento de intervención cuando la intervención está habilitada',
    'driverPerformanceFunctionTab_intervention_updatedConfiguration': 'Configuración Guardada Correctamente',
    'driverPerformanceFunctionTab_intervention_updatedConfigurationError': 'Error al Guardar la Configuración',
    'driverPerformanceFunctionTab_intervention_coachingEducationRequired': 'Coaching Education debe estar habilitado antes de activar Intervención',
    'driverPerformanceFunctionTab_intervention_severityTooltip': 'Rango de severidad: 1-100',
    'driverPerformanceFunctionTab_intervention_selectProfile': 'Seleccionar Perfil',

    // Traducciones de categorías de eventos
    'eventCategory_aggression': 'Agresión',
    'eventCategory_adas': 'ADAS',
    'eventCategory_dms': 'DMS',

    // Traducciones de eventos
    'event_power_lost': 'Pérdida de Energía',
    'event_rapid_acceleration': 'Aceleración Rápida',
    'event_hard_brake': 'Frenado Brusco',
    'event_potential_incident': 'Incidente Potencial',
    'event_speed_threshold': 'Umbral de Velocidad',
    'event_hard_turn': 'Giro Brusco',
    'event_collision_warning': 'Advertencia de Colisión',
    'event_close_following': 'Seguimiento Cercano',
    'event_tailgating': 'Conducción Pegada',
    'event_asleep': 'Dormido',
    'event_yawn': 'Bostezo',
    'event_drowsiness': 'Somnolencia',
    'event_using_phone': 'Usando Teléfono',
    'event_distracted': 'Distraído',
    'event_smoking': 'Fumando',
    'event_no_seatbelt': 'Sin Cinturón de Seguridad',
    'event_manual': 'Manual',
    'event_stop_sign_violation': 'Violación de Señal de Alto',
    'event_camera_obstructed': 'Cámara Obstruida',
    'event_idle_no_driver': 'Ralentí Sin Conductor',
    'event_lane_departure': 'Salida de Carril',
    'event_posted_speed': 'Velocidad Permitida',
    'event_pedestrian_detection': 'Detección de Peatón',
    'event_cyclist_warning': 'Advertencia de Ciclista',
    'event_passenger_inside': 'Pasajero Dentro',
    'event_passenger_seatbelt': 'Cinturón de Seguridad del Pasajero',
    'event_unassigned_driver': 'Conductor No Asignado',
    'event_parking_hit': 'Golpe en Estacionamiento',
    'event_sdcarderror': 'Error de Tarjeta SD'
};
